import { Directive, Input, TemplateRef } from '@angular/core';
import {
  EventApi,
  EventContentArg,
  EventInput,
  ViewApi,
} from '@fullcalendar/core';

export class ResourceCalendarEventTemplateContext {
  $implicit!: EventApi | EventInput;
  event!: EventApi | EventInput;
  view!: ViewApi | null;
  data!: EventContentArg | null;
  entity?: any;
}

export type ResourceCalendarTemplateType = 'title' | 'content' | 'event';

@Directive({
  selector: '[konCalendarEvent]',
  standalone: true,
})
export class ResouceCalendarEventDirective {
  constructor(public readonly template: TemplateRef<any>) {}

  // this magic is how we tell Angular the context type for this directive, which then propagates down to the type of the template
  static ngTemplateContextGuard(
    dir: ResouceCalendarEventDirective,
    ctx: any,
  ): ctx is ResourceCalendarEventTemplateContext {
    return true;
  }

  @Input({ alias: 'konCalendarEvent', required: true })
  type: ResourceCalendarTemplateType = 'event';
}
